import * as React from "react";
import BankAccount from "./BankAccount";
import Card from "@mui/material/Card";
import Stack from '@mui/material/Stack';
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import {useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";
import {useCookies} from "react-cookie";


function FinanceStatus() {
    const [accountStatus, setAccountStatus] = useState(0);
    const [recentTransactions, setRecentTransactions] = useState(<p></p>);
    const navigate = useNavigate();
    const [cookies, setCookie, removeCookie] = useCookies(['session-token']);

    useEffect(() => {
        if (typeof cookies['session-token'] === "string" && cookies['session-token'].length > 0) {
            fetch('/api/account_status', {
                method: 'POST',
                headers: {'Content-Type': 'application/json'},
                body: JSON.stringify({
                    session: cookies['session-token'],
                })
            }).then(res => {
                // Check if the response is not OK (e.g. 401 Unauthorized)
                if (!res.ok) {
                    if (res.status === 401) {
                        // The session is invalid, so remove the cookie
                        setCookie('session-token', '');
                        removeCookie('session-token', { path: '/' });
                        // Redirect to the login page
                        navigate('/sign-in');
                    }
                    // Throw an error to stop the promise chain
                    throw new Error(`HTTP error! status: ${res.status}`);
                }
                // If the response is OK, parse the JSON
                return res.json();
            }).then(data => {

                setAccountStatus(data);

                setRecentTransactions(
                    data['recent_transactions'].map((transaction) =>
                        <Box key={transaction['id']} sx={{
                            backgroundColor: 'background.paper',
                            padding: '16px',
                            borderRadius: '8px',
                            margin: '1em 0 0 0',
                        }}>
                            <Grid container alignItems="center">
                                <Grid item xs={12} sm={8}> {/* Adjust breakpoint for responsiveness */}
                                    <Typography variant="body1" sx={{fontWeight: 500}}>
                                        {transaction['peer']}
                                    </Typography>
                                    <Box sx={{display: 'flex', alignItems: 'center', marginTop: '4px'}}>
                                        <div style={{
                                            borderRadius: '10px', padding: '0 10px',
                                            backgroundColor: transaction['status'] === "vorgemerkt" ? '#FFC107' : '#5b5b5e'
                                        }}>
                                            {transaction['status']}
                                        </div>
                                        <Typography variant="body2" sx={{color: '#A0A3A8'}}>
                                            <span style={{margin: '0 .5em'}}>•</span>{transaction['date']}
                                        </Typography>
                                    </Box>
                                </Grid>
                                <Grid item xs={12} sm={4} textAlign="right"> {/* Align amount to the right */}
                                    <Typography variant="body1" sx={{
                                        color: transaction['value'] >= 0 ? '#6aff07' : '#ff3a1b',
                                        fontWeight: 500
                                    }}>
                                        {(transaction['value'] / 100).toFixed(2).replace(".", ",").replace(
                                            /(\d)(?=(\d{3})+(?!\d))/g, '$1.')} €
                                    </Typography>
                                </Grid>
                            </Grid>
                        </Box>
                    ));
            });
        }
    }, []);

    return (
        <Card variant="outlined" style={{maxWidth: '50em'}}>
            <BankAccount iban={accountStatus['IBAN']} balance={accountStatus['balance']}/>
            <Stack spacing={2} direction="row">
                <Button variant="contained" onClick={() => navigate('/transaction')}>Überweisung</Button>
                <Button variant="outlined">Umsatzliste</Button>
                <Button variant="outlined">Kontodetails</Button>
            </Stack>

            {recentTransactions}
        </Card>
    )
        ;
}

export default FinanceStatus;